import { z } from 'zod';

export const appThemeSchema = z.enum(['light', 'dark']);
export type AppThemePreference = z.infer<typeof appThemeSchema>;

export const userPreferencesSchema = z.object({
  userId: z.string().min(1),
  fullName: z.string().trim().min(1).max(160),
  firstName: z.string().trim().max(80).optional(),
  familyName: z.string().trim().max(80).optional(),
  phone: z.string().trim().max(30).optional(),
  bio: z.string().trim().max(500).optional(),
  pictureUrl: z.url().startsWith('https://').or(z.literal('')),
  timezone: z.string().trim().min(1).max(100),
  theme: appThemeSchema,
  // This is a display preference only. It must not record a reason for use or
  // any health or disability information.
  accessibilityDisplayEnabled: z.boolean(),
  lastSeenAt: z.string().datetime().optional(),
  updatedAt: z.string().datetime(),
});

export type UserPreferences = z.infer<typeof userPreferencesSchema>;

export const updateUserPreferencesSchema = userPreferencesSchema
  .pick({
    fullName: true,
    firstName: true,
    familyName: true,
    phone: true,
    bio: true,
    pictureUrl: true,
    timezone: true,
    theme: true,
    accessibilityDisplayEnabled: true,
  })
  .partial()
  .strict()
  .refine((value) => Object.keys(value).length > 0, 'At least one preference must be updated');

export type UpdateUserPreferences = z.infer<typeof updateUserPreferencesSchema>;
